import Immutable from 'immutable'

export function isImmutable({ value }: { value: any }) {
  return Immutable.Iterable.isIterable(value)
}
